import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableCellProps,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
const cellStyles: TableCellProps = {
  align: 'left',
  sx: {
    p: 0
  }
}
const titleCellStyles: TableCellProps = {
  align: 'left',
  sx: {
    p: 1
  }
}
export const VehicleTireInfoSection = () => {
  return (
    <Stack
      direction="column"
      justifyContent="flex-start"
      mx={2}
      sx={{ borderBottom: 1, borderColor: '#424242' }}>
      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
        Vehicle Tire Information
      </Typography>
      <Stack direction="row" spacing={1}>
        <CheckBoxOutlineBlankIcon />
        <Typography variant="subtitle1">
          Check not performed due to tires deemed unsafe.
        </Typography>
      </Stack>
      <Box>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell {...cellStyles}></TableCell>
              <TableCell {...cellStyles}>Left Front</TableCell>
              <TableCell {...cellStyles}>Right Front</TableCell>
              <TableCell {...cellStyles}>Left Rear</TableCell>
              <TableCell {...cellStyles}>Right Rear</TableCell>
              <TableCell {...cellStyles}>Checked By</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell {...titleCellStyles}>Tire Pressure PSI</TableCell>
              <TableCell {...cellStyles} colSpan={5}></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </Stack>
  )
}
